import {
  MONTHLY_CHECK, MONTHLY_CHECK_SUCCESS, MONTHLY_CHECK_FAILURE,
  MONTHLY_CHECK_CSV, MONTHLY_CHECK_CSV_SUCCESS, MONTHLY_CHECK_CSV_FAILURE
} from './mutation-types'

export default {
  state: {
    facilities: [],
    total: 0,
    monthlyCheckNextPageNumber: null,
    monthlyCheckCurrentPage: null,
    csvFileName: null
  },
  getters: {
    monthlyFacilities: state => {
      return state.facilities
    },
    monthlyFacilitiesTotal: state => {
      return state.total
    },
    monthlyCheckNextPageNumber: state => {
      return state.monthlyCheckNextPageNumber
    },
    monthlyCheckCurrentPage: state => {
      return state.monthlyCheckCurrentPage
    },
    csvFileName: state => {
      return state.csvFileName
    }
  },
  actions: {
    [MONTHLY_CHECK] ({dispatch, state, commit}, params = null) {
      console.log('MONTHLY_CHECK')
      var callback = () => {}
      var data = {}
      var loadparams = 'block'
      if (params) {
        data = params.data
      }
      dispatch('apiGet', { url: '/monthly', data: data, loadparams: loadparams })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MONTHLY_CHECK_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(MONTHLY_CHECK_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MONTHLY_CHECK_CSV] ({dispatch, state, commit}, params = null) {
      console.log('MONTHLY_CHECK_CSV')
      var callback = () => {}
      var data = {}
      if (params) {
        data = params.data
        callback = params.callback
      }
      dispatch('apiGet', { url: '/monthly', data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MONTHLY_CHECK_CSV_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(MONTHLY_CHECK_CSV_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [MONTHLY_CHECK_FAILURE] (state, data) {
      console.log('MONTHLY_CHECK_FAILURE')
    },
    [MONTHLY_CHECK_SUCCESS] (state, data) {
      console.log('MONTHLY_CHECK_SUCCESS')
      state.total = data.data.total
      if (data.data.meta && data.data.meta['current_page'] && data.data.meta['current_page'] > 1) {
        state.facilities = state.facilities.concat(data.data.facilities)
        state.monthlyCheckCurrentPage = data.data.meta['current_page']
      } else {
        state.facilities = data.data.facilities
        state.monthlyCheckCurrentPage = 1
      }
      if (data.data.meta && data.data.meta['next_page']) {
        state.monthlyCheckNextPageNumber = data.data.meta['next_page']
      } else {
        state.monthlyCheckNextPageNumber = null
      }
    },
    [MONTHLY_CHECK_CSV_FAILURE] (state, data) {
      console.log('MONTHLY_CHECK_CSV_FAILURE')
    },
    [MONTHLY_CHECK_CSV_SUCCESS] (state, data) {
      console.log('MONTHLY_CHECK_CSV_SUCCESS')
      state.total = data.data.total
      state.facilities = data.data.facilities
      state.csvFileName = data.data.file_name
      data.callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/monthly-check.js